import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

// ─── 1. ESTILOS GLOBALES ──────────────────────────────────────────────────────
const GlobalStyles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;1,300;1,400;1,600&family=Cinzel:wght@400;600;900&family=Josefin+Sans:wght@100;300;400&family=Great+Vibes&display=swap');
    
    * { margin: 0; padding: 0; box-sizing: border-box; }
    
    html, body { 
      overflow: hidden; 
      width: 100%; 
      height: 100%; 
      background: #0E0B07; 
    }
    
    .snap-container { 
      height: 100dvh; 
      overflow-y: scroll; 
      scroll-snap-type: y mandatory; 
      scroll-behavior: smooth; 
      scrollbar-width: none; 
    }
    .snap-container::-webkit-scrollbar { display: none; }
    
    .snap-section { 
      height: 100dvh; 
      scroll-snap-align: start; 
      scroll-snap-stop: always; 
      position: relative; 
      overflow: hidden; 
      display: flex; 
      flex-direction: column; 
      align-items: center; 
      justify-content: center; 
      text-align: center;
    }
    
    .sky-magic {
      background: linear-gradient(-45deg, #74b9ff, #a29bfe, #74b9ff, #81ecec);
      background-size: 400% 400%;
      animation: auroraSky 12s ease infinite;
    }
    @keyframes auroraSky {
      0% { background-position: 0% 50%; }
      50% { background-position: 100% 50%; }
      100% { background-position: 0% 50%; }
    }

    .floating-text {
      color: #fff;
      text-shadow: 0 2px 10px rgba(0,0,0,0.3);
      position: relative;
      z-index: 10;
      width: 90%; 
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .text-shimmer { 
      background: linear-gradient(90deg, #8B6914 0%, #E8CC7A 40%, #C9A84C 50%, #E8CC7A 60%, #8B6914 100%); 
      background-size: 200% auto; 
      -webkit-background-clip: text; 
      -webkit-text-fill-color: transparent; 
      animation: shimmer 4s linear infinite; 
    }
    @keyframes shimmer { 0% { background-position: -200% center; } 100% { background-position: 200% center; } }
  `}</style>
);

// ─── 2. COMPONENTES DE APOYO REFINADOS ────────────────────────────────────────

const WaxSeal = () => (
  <div style={{ 
    width: '110px', height: '110px', borderRadius: '50%', 
    backgroundColor: '#C9A84C', display: 'flex', alignItems: 'center', justifyContent: 'center', 
    boxShadow: '0 8px 20px rgba(0,0,0,0.5), inset 0 4px 6px rgba(255,255,255,0.3)',
    border: '1px solid rgba(139, 105, 20, 0.4)', position: 'relative', overflow: 'hidden'
  }}>
    {/* Textura del lacre */}
    <div style={{
      position: 'absolute', inset: '-10%',
      backgroundImage: 'url("/textura-lacre.png")',
      backgroundSize: 'cover', backgroundPosition: 'center',
      opacity: 0.7, zIndex: 1, mixBlendMode: 'multiply'
    }} />
    <span style={{ 
      fontFamily: 'Cinzel', color: '#fff', fontWeight: '900', fontSize: '32px', 
      zIndex: 2, textShadow: '2px 2px 4px rgba(0,0,0,0.3)' 
    }}>SC</span>
  </div>
);

const BlueEnvelope = ({ onOpen }) => {
  const [isOpening, setIsOpening] = useState(false);
  const handleOpen = () => { setIsOpening(true); setTimeout(onOpen, 1400); };

  return (
    <motion.div exit={{ opacity: 0, scale: 1.05 }} transition={{ duration: 0.8 }}
      style={{ position: 'fixed', inset: 0, zIndex: 100, background: '#0E0B07', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      
      <div style={{ position: 'relative', width: '300px', height: '440px', perspective: '1500px' }}>
        
        {/* Tarjeta Interna (La que se revela) */}
        <div style={{ 
          position: 'absolute', inset: '10px', background: '#FAF6EE', 
          backgroundImage: 'url("https://www.transparenttextures.com/patterns/natural-paper.png")',
          borderRadius: '4px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', 
          padding: '30px', zIndex: 1, boxShadow: '0 10px 30px rgba(0,0,0,0.5)'
        }}>
          <p style={{ fontFamily: 'Cinzel', color: '#8B6914', fontSize: '11px', letterSpacing: '0.3em' }}>SARA CAMILA</p>
          <div style={{ width: '35px', height: '1px', background: '#C9A84C', margin: '20px 0' }} />
          <p style={{ fontFamily: 'Great Vibes', color: '#1C1610', fontSize: '28px' }}>¡Estás invitado!</p>
        </div>

        {/* Sobre Exterior (La tapa con textura azul) */}
        <motion.div 
          animate={isOpening ? { rotateY: -130, x: '-10%', opacity: 0 } : { rotateY: 0 }} 
          transition={{ duration: 1.5, ease: [0.65, 0, 0.35, 1] }} 
          onClick={handleOpen}
          style={{ 
            position: 'absolute', inset: 0, 
            backgroundImage: 'url("/textura-papel-azul.jpg")', 
            backgroundSize: 'cover', borderRadius: '8px', zIndex: 3, cursor: 'pointer', 
            display: 'flex', alignItems: 'center', justifyContent: 'center', transformOrigin: 'left center',
            boxShadow: '15px 0 35px rgba(0,0,0,0.4)', borderLeft: '1px solid rgba(255,255,255,0.1)'
          }}
        >
          <WaxSeal />
          <p style={{ position: 'absolute', bottom: '45px', color: 'rgba(255,255,255,0.8)', fontFamily: 'Josefin Sans', fontSize: '8px', letterSpacing: '0.4em' }}>TOCA PARA ABRIR</p>
        </motion.div>
      </div>
    </motion.div>
  );
};

const SectionBackground = ({ src, opacity = 0.5, isDark = true }) => (
  <>
    <div style={{
      position: 'absolute', inset: 0,
      backgroundImage: src ? `url(${src})` : 'none',
      backgroundColor: '#0E0B07',
      backgroundSize: 'cover', backgroundPosition: 'center',
      zIndex: 0, opacity: opacity 
    }} />
    {isDark && (
      <div style={{
        position: 'absolute', inset: 0,
        background: 'linear-gradient(to bottom, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.6) 60%, #0E0B07 100%)',
        zIndex: 1, pointerEvents: 'none'
      }} />
    )}
  </>
);

const StarParticles = () => (
  <div style={{ position: 'absolute', inset: 0, pointerEvents: 'none', zIndex: 1 }}>
    {[...Array(25)].map((_, i) => (
      <motion.div
        key={i}
        animate={{ opacity: [0, 1, 0], scale: [0, 1, 0] }}
        transition={{ duration: Math.random() * 4 + 3, repeat: Infinity, delay: Math.random() * 5 }}
        style={{
          position: 'absolute', top: Math.random() * 100 + '%', left: Math.random() * 100 + '%',
          width: '2px', height: '2px', background: 'white', borderRadius: '50%', boxShadow: '0 0 8px white'
        }}
      />
    ))}
  </div>
);

// ─── 3. SECCIONES DE CONTENIDO ────────────────────────────────────────────────
const ParentsSection = () => (
  <div className="snap-section sky-magic">
    <StarParticles />
    <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} className="floating-text">
      <p style={{ fontFamily: 'Cinzel', fontSize: '14px', color: '#ffd700', letterSpacing: '0.4em', marginBottom: '20px' }}>MIS PADRES</p>
      
      <h2 style={{ fontFamily: 'Cormorant Garamond', fontSize: '32px', fontStyle: 'italic' }}>Pablo Daniel Tapias Matallana</h2>
      <div style={{ margin: '5px 0', fontSize: '20px' }}>&</div>
      <h2 style={{ fontFamily: 'Cormorant Garamond', fontSize: '32px', fontStyle: 'italic', marginBottom: '25px' }}>Sonia Rocío Cujaban Montaña</h2>

      {/* Sección de la hermana */}
      <p style={{ fontFamily: 'Cinzel', fontSize: '12px', color: '#ffd700', letterSpacing: '0.3em', marginBottom: '10px' }}>MI HERMANA</p>
      <h3 style={{ fontFamily: 'Cormorant Garamond', fontSize: '26px', fontStyle: 'italic', marginBottom: '30px', color: 'rgba(255,255,255,0.95)' }}>
        Laura Juliana Tapias Cujaban
      </h3>

      <p style={{ fontFamily: 'Josefin Sans', fontSize: '15px', color: 'rgba(255,255,255,0.9)', maxWidth: '280px', margin: '0 auto' }}>
        Tienen el honor de invitarles a celebrar los quince años de su hija y hermana.
      </p>
    </motion.div>
  </div>
);

const DetailsSection = () => (
  <div className="snap-section sky-magic">
    <StarParticles />
    <motion.div initial={{ opacity: 0, scale: 0.9 }} whileInView={{ opacity: 1, scale: 1 }} className="floating-text">
      <p style={{ fontFamily: 'Great Vibes', fontSize: '45px', marginBottom: '25px' }}>Detalles</p>
      <div style={{ marginBottom: '40px' }}>
        <div style={{ fontSize: '35px', marginBottom: '10px' }}>✉️</div>
        <p style={{ fontFamily: 'Josefin Sans', fontSize: '14px', maxWidth: '280px' }}>
          Mi mejor regalo es tu presencia. Si deseas obsequiarme algo, te agradezco la lluvia de sobres.
        </p>
      </div>
      <div style={{ height: '1px', width: '40px', background: 'rgba(255,255,255,0.5)', marginBottom: '40px' }} />
      <div>
        <div style={{ fontSize: '35px', marginBottom: '10px' }}>👔👗</div>
        <p style={{ fontFamily: 'Cinzel', fontSize: '20px', color: '#ffd700', marginBottom: '10px' }}>Dress Code</p>
        <p style={{ fontFamily: 'Cinzel', fontSize: '16px', fontWeight: 'bold' }}>FORMAL</p>
        <p style={{ fontFamily: 'Josefin Sans', fontSize: '11px', color: 'rgba(255,255,255,0.7)', fontStyle: 'italic', marginTop: '10px' }}>
          *Se reserva el uso de tonos azules para el uso exclusivo de la quinceañera.
        </p>
      </div>
    </motion.div>
  </div>
);

const EventSection = ({ title, place, address, img, mapUrl, showIcon = false }) => (
  <div className="snap-section">
    <SectionBackground src={img} opacity={0.7} />
    <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} className="floating-text">
      {showIcon && <div style={{ fontSize: '50px', marginBottom: '10px' }}>⛪</div>}
      <p style={{ fontFamily: 'Josefin Sans', fontSize: '10px', color: '#C9A84C', letterSpacing: '0.4em' }}>{title}</p>
      <h2 style={{ fontFamily: 'Cormorant Garamond', fontSize: '32px', fontStyle: 'italic', margin: '10px 0' }}>{place}</h2>
      <p style={{ fontFamily: 'Josefin Sans', fontSize: '12px', marginBottom: '20px' }}>{address}</p>
      <button onClick={() => window.open(mapUrl, '_blank')} style={{ padding: '12px 30px', borderRadius: '40px', background: 'transparent', border: '1px solid #C9A84C', color: '#C9A84C', fontSize: '10px', cursor: 'pointer' }}>UBICACIÓN</button>
    </motion.div>
  </div>
);

const CountdownSection = () => {
  const [time, setTime] = useState({ d: 0, h: 0, m: 0, s: 0 });
  useEffect(() => {
    const timer = setInterval(() => {
      const diff = new Date('2026-06-06T18:13:00').getTime() - new Date().getTime();
      if (diff > 0) setTime({ d: Math.floor(diff/(864e5)), h: Math.floor((diff/36e5)%24), m: Math.floor((diff/6e4)%60), s: Math.floor((diff/1e3)%60) });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return (
    <div className="snap-section">
      <SectionBackground src="/padrinos.jpg" opacity={0.6} />
      <div className="floating-text">
        <p style={{ fontFamily: 'Great Vibes', fontSize: '40px', color: '#C9A84C', marginBottom: '20px' }}>Falta muy poco...</p>
        <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
          {[{l:'Días',v:time.d},{l:'Hrs',v:time.h},{l:'Min',v:time.m},{l:'Seg',v:time.s}].map(i => (
            <div key={i.l} style={{ minWidth: '60px' }}>
              <div style={{ fontFamily: 'Cinzel', fontSize: '24px' }}>{String(i.v).padStart(2,'0')}</div>
              <div style={{ fontFamily: 'Josefin Sans', fontSize: '9px', color: '#C9A84C' }}>{i.l}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const RSVPSection = () => {
  const [count, setCount] = useState(1);
  const sendWA = () => window.open(`https://wa.me/573123948325?text=Confirmo asistencia (${count} pers.)`, '_blank');
  return (
    <div className="snap-section">
      <SectionBackground src="/final.jpg" opacity={0.6} /> 
      <div className="floating-text">
        <h2 style={{ fontFamily: 'Cormorant Garamond', fontSize: '36px', fontStyle: 'italic', marginBottom: '25px' }}>Confirmación</h2>
        <div style={{ marginBottom: '35px', display: 'flex', alignItems: 'center', gap: '25px', justifyContent: 'center' }}>
          <button onClick={() => setCount(Math.max(1, count - 1))} style={{ background: 'none', border: '1px solid #C9A84C', color: '#C9A84C', width: '45px', height: '45px', borderRadius: '50%', cursor: 'pointer' }}>-</button>
          <span style={{ fontSize: '30px', fontFamily: 'Cinzel' }}>{count}</span>
          <button onClick={() => setCount(count + 1)} style={{ background: 'none', border: '1px solid #C9A84C', color: '#C9A84C', width: '45px', height: '45px', borderRadius: '50%', cursor: 'pointer' }}>+</button>
        </div>
        <button onClick={sendWA} style={{ width: '220px', padding: '15px', background: '#C9A84C', border: 'none', borderRadius: '50px', fontWeight: 'bold', color: '#fff', cursor: 'pointer' }}>WHATSAPP</button>
      </div>
    </div>
  );
};

// ─── 4. APP PRINCIPAL ─────────────────────────────────────────────────────────

export default function App() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <GlobalStyles />
      <AnimatePresence>
        {!isOpen && <BlueEnvelope onOpen={() => setIsOpen(true)} />}
      </AnimatePresence>

      {isOpen && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="snap-container">
          {/* Seccion 1: Portada */}
          <div className="snap-section">
            <SectionBackground src="/inicio.jpg" opacity={0.7} />
            <div className="floating-text">
              <p style={{ fontFamily: 'Josefin Sans', fontSize: '11px', letterSpacing: '0.5em', color: '#C9A84C' }}>MIS QUINCE AÑOS</p>
              <h1 className="text-shimmer" style={{ fontFamily: 'Cormorant Garamond', fontSize: '55px', fontStyle: 'italic' }}>Sara Camila</h1>
              <p style={{ fontFamily: 'Cinzel', fontSize: '14px' }}>06.06.2026</p>
            </div>
          </div>

          <ParentsSection />
          <CountdownSection />
          
          <EventSection title="Ceremonia" place="Parroquia Sagrado Corazón de Jesús" address="Sogamoso" img="/iglesia.jpg" showIcon={true} mapUrl="https://maps.app.goo.gl/ZkzA8Td4YJs1mvRWA" />
          <EventSection title="Recepción" place="Banquetes Fiestas" address="Sogamoso" img="/recep.jpg" mapUrl="https://maps.app.goo.gl/9HMNgSrVMU8vYDSD9" />

          <DetailsSection />
          <RSVPSection />

          <div className="snap-section">
            <SectionBackground src="/tiempo.jpg" opacity={0.7} />
            <div className="floating-text">
              <h2 style={{ fontFamily: 'Great Vibes', fontSize: '45px', color: '#C9A84C' }}>Gracias</h2>
              <p style={{ fontFamily: 'Cormorant Garamond', fontSize: '20px', fontStyle: 'italic' }}>Por acompañarme.</p>
            </div>
          </div>
        </motion.div>
      )}
    </>
  );
}